// Sign-up moments' flag, signup_moments (#5195; founder pick A, 2026-10-23).
// A rollout gate, not a kill switch; retire it once it is on for everyone
// (ADR 0038), with today's prompts, in one PR.
//
// The moments are shown to signed-out visitors, so "Just us" cannot reach
// them by account: only Everyone does (a public flag; the college pages are
// prerendered with the public flags, so going live is the flag AND a frontend
// deploy). The team previews on a team device with ?signup_preview=1 (kept
// for this tab; ?signup_preview=0 ends it), the useLandingStory pattern:
// read after mount, and never on a stranger's browser (isOurBrowser).
// Nothing a moment adds is prerendered: every box appears after the visitor
// acts, so the first paint is the same either way.
import { useEffect, useState } from 'react';
import { isOurBrowser } from '../services/analytics';
import { useFeatureFlags } from '../context/FeatureFlagsContext';

export const SIGNUP_MOMENTS_FLAG = 'signup_moments';
export const SIGNUP_PREVIEW_PARAM = 'signup_preview';
const PREVIEW_KEY = 'stratia_signup_preview';

/** Whether this tab asked for the preview, on a team device. Never throws. */
export function signupPreviewRequested() {
    try {
        const ask = new URLSearchParams(window.location.search).get(SIGNUP_PREVIEW_PARAM);
        if (ask === '1') sessionStorage.setItem(PREVIEW_KEY, '1');
        if (ask === '0') sessionStorage.removeItem(PREVIEW_KEY);
        return sessionStorage.getItem(PREVIEW_KEY) === '1' && isOurBrowser();
    } catch {
        return false;
    }
}

/** Pure: on when the flag is on for everyone, or in a team preview. */
export function signupMomentsOn({ publicFlags, preview = false }) {
    return Boolean(publicFlags?.[SIGNUP_MOMENTS_FLAG]) || Boolean(preview);
}

/** The page's answer: the public flag, or the preview once mounted. */
export default function useSignupMoments() {
    const { publicFlags } = useFeatureFlags({ mine: false, public: true }) || {};
    const [preview, setPreview] = useState(false);
    useEffect(() => { setPreview(signupPreviewRequested()); }, []);
    return signupMomentsOn({ publicFlags, preview });
}
